import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../../../shared/service/breadcrumb.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { NotificationDetailService } from '../../../../modules/settings/user-notification/service/notification-detail.service';
import { EnvironmentService } from '../../../../shared/environment.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent implements OnInit {
  showModal = false;
  notifications: any[] = [];
  filteredNotifications: any[] = []; // Array to store filtered notifications
  loading: boolean = true;

  @Output() modalClosed = new EventEmitter<void>();
  selectedMenu: any = [
    { label: 'Home', url: '/dashboard' },
    { label: 'Notifications', url: '/notification-detail' },
  ];

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public sharedDataService: SharedDataService,
    private notificationService: NotificationDetailService,
    public envService: EnvironmentService,
    public translate: TranslateService,
    private planningDataService: PlanningDataService,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(status?: string) {
    this.loading = true;
    const params: any = {
      page: 0,
      size: 5,
      status:'UNREAD'
    };
    // Add status to params only if it's provided
    if (status) {
      params.status = status;
    }
    this.notificationService.fetchAllNotifications(params).subscribe({
      next: (response: any) => {
        if(response?.body?.content?.length>0){
          this.sharedDataService.unreadNotfCount=response?.body?.content[0]?.unReadNotificationCount;
        }
        this.notifications = response.body.content.map((notification: any) => {
          let swapInitUserImage=null;
          let swapTransfUserImage=null;

          // Parse as UTC and convert to local time
          const localDate = moment.utc(notification.createdAt, 'DD.MM.YYYY hh:mm A').local();
          const dateString = localDate.format('DD.MM.YYYY');
          const formattedTime = localDate.format('HH:mm');

          // Format date dynamically with translation
          const formattedDate = this.getTranslatedRelativeDate(dateString);
          const formattedDateValue = formattedDate + ` ${this.translate.instant('constants.DATE.at')} ` + formattedTime;
          if(['SWAP_DUTY_APPROVE', 'SWAP_DUTY_APPROVED', 'SWAP_DUTY_DECLINED', 'SWAP_DUTY_REJECTED', 'SWAP_DUTY_CANCELLED'].includes(notification.type)){
            swapInitUserImage=notification.intiatedStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.intiatedStaffImage}`
            : 'assets/image/default-avatar.webp';
            swapTransfUserImage=notification.transferStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.transferStaffImage}`
            : 'assets/image/default-avatar.webp'
          }
          return {
            id: notification.id,
            title: notification.title,
            message: notification.message,
            time: formattedDateValue,
            avatar: notification.staff.imageUrl
              ? `${this.envService.imgReviewUrl}/${notification.staff.imageUrl}`
              : 'assets/image/default-avatar.webp',
            swapAvatar: notification?.intiatedStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.intiatedStaffImage}`
            : 'assets/image/default-avatar.webp',
            swapInitUserImage:swapInitUserImage,
            swapTransfUserImage:swapTransfUserImage,
            status: notification.status,
            type: notification.type
          };
        });

        this.filteredNotifications = this.notifications;
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
    });
  }
// Helper function to get translated relative date
getTranslatedRelativeDate(dateString: string): string {
  const date = moment(dateString, 'DD.MM.YYYY').locale('en');
  const now = moment();

  // Today
  if (now.isSame(date, 'day')) {
    return this.translate.instant('constants.DATE.TODAY');
  }

  // Yesterday
  if (now.subtract(1, 'days').isSame(date, 'day')) {
    return this.translate.instant('constants.DATE.YESTERDAY');
  }

  // Last week
  if (now.subtract(6, 'days').isSameOrBefore(date, 'day')) {
    const weekdayName = date.toDate().toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();
    const weekdayKey = `constants.DATE.${weekdayName}`;
    return `${this.translate.instant(
      'constants.DATE.LAST'
    )} ${this.translate.instant(weekdayKey)}`;
  }

  // Other dates
  const monthName = date.toDate().toLocaleDateString('en-US', { month: 'long' }).toUpperCase();
  const monthKey = `constants.MONTH.${monthName}`; // Example: MONTH.JANUARY
  const translatedMonth = this.translate.instant(monthKey);

  // Check if the year is the current year
  if (now.isSame(date, 'year')) {
    // Only display month and day
    return `${translatedMonth} ${date.format('D')}`;
  } else {
    // Display month, day, and year for past years
    return `${translatedMonth} ${date.format('D')}, ${date.format('YYYY')}`;
  }
}
  filterNotifications(tabIndex: number) {
    switch (tabIndex) {
      case 0: // All notifications
        this.loadNotifications(); // No status passed
        break;
    }
  }

  toggleModal() {
    this.showModal = !this.showModal;
    if (this.showModal) {
      this.loadNotifications();
    }
    if (!this.showModal) {
      this.modalClosed.emit();
    }
  }

  closeModal() {
    this.showModal = false;
    this.modalClosed.emit();
  }

  viewAllNotifications() {
    this.router.navigate(['/notification-detail']);
    this.planningDataService.setSelRouterLink('/notification-detail');
    this.closeNotificationModal();
  }

  openNotificationDetail(notification: any) {
    this.planningDataService.setSelRouterLink(`/notification-detail/${notification?.id}`);
    this.router.navigate(['/notification-detail', notification.id], { queryParams: { filter: 'UNREAD' } });
    this.closeNotificationModal();
  }

  closeNotificationModal() {
    this.sharedDataService.activeTab = '/notification-detail';
    this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    this.closeModal();
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
